import React, { useCallback, useEffect, useRef, useState } from 'react';
import { classNames } from 'primereact/utils';
import { __ } from '@wordpress/i18n';
import { isEmpty, isNil, pathOr, pluck } from 'ramda';

// service
import FileUploadService from '../../../../service/file-upload-service';
import CompanyDocumentsService from '../../../../service/company-documents-service';

// components
import { ListBox } from 'primereact/listbox';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';

const FileSelect = ({
                        fieldName,
                        label,
                        setDataFn,
                        register,
                        errors,
                        defaultValue,
                        multiple = false,
                        config = {},
                        infoText = null,
                        disabled = false,
                        options = [],
                        sourceId = 0,
                        source = 'DOCUMENT',
                        documentCategories = [],
                        saveFormCallback,
                        attachFilesCallback,
                    }) => {
    //const [stateFieldData, setStateFieldData] = useState([]);
    const stateFieldData = useRef([]);
    const [selectedUnconfirmed, setSelectedUnconfirmed] = useState([]);
    const [optionsTransformed, setOptionsTransformed] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addNewMode, setAddNewMode] = useState(false);

    const attachSelectedFiles = useCallback(() => {
        const existingIds = pluck('id', stateFieldData.current);
        const selectedToBeAdded = selectedUnconfirmed.filter(o => !existingIds.includes(o.id));
        setSelectedUnconfirmed([]);

        setLoading(true);
        // eslint-disable-next-line array-callback-return
        selectedToBeAdded.map(o => {
            CompanyDocumentsService.attachCompanyDocumentToAppl(o.id, callback, errCallback, [
                ['applicationId', sourceId],
                ['documentType', source]
            ])
        });
        setAddNewMode(false);
    }, [selectedUnconfirmed]);

    const attachSelectedFilesCallback = useCallback(() => {
        const existingIds = pluck('id', stateFieldData.current);
        const selectedToBeAdded = selectedUnconfirmed.filter(o => !existingIds.includes(o.id));
        setSelectedUnconfirmed([]);

        // eslint-disable-next-line array-callback-return
        selectedToBeAdded.map(o => attachFilesCallback(o));
        setAddNewMode(false);
    }, [selectedUnconfirmed]);

    const doGoBackToListOfFiles = () => {
        setSelectedUnconfirmed([]);
        setAddNewMode(false);
    }

    const callback = (resp) => {
        if (resp.status === 'SUCCESS') {
            stateFieldData.current = [...stateFieldData.current, resp.data];
            setDataFn(fieldName, stateFieldData.current, { shouldValidate: true });
            saveFormCallback();
        }
        setLoading(false);
    }

    const errCallback = () => {
        setLoading(false);
    }

    const removeAttached = (id) => {
        FileUploadService.deleteFile(
            {},
            (data) => deleteCallback(data, id),
            deleteErrorCallback,
            [['id', id]]
        );
    }

    const deleteCallback = (data, id) => {
        if (data.status === 'SUCCESS') {
            stateFieldData.current = stateFieldData.current.filter(o => id !== o.id);
            setDataFn(fieldName, stateFieldData.current, { shouldValidate: true });
            saveFormCallback();
        }
    }

    const deleteErrorCallback = (err) => {
        console.log('err', err);
    }

    const confirmDelete = (event, id) => {
        confirmPopup({
            target: event.currentTarget,
            message: __('Sei sicuro di cancellare il file?', 'htr'),
            acceptLabel: __('Si', 'htr'),
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => removeAttached(id),
            reject: () => {
            }
        });
    };

    useEffect(() => {
        stateFieldData.current = defaultValue;
        register(fieldName, config)
    }, []);

    useEffect(() => {
        if (!isEmpty(options)) {
            const optionsDefault = options
                .filter(o => isEmpty(documentCategories)
                    ? o
                    : documentCategories.includes(o.category.id))
                .reduce((acc, cur) => {
                    const catName = pathOr('', ['category', 'categoryName'], cur);
                    const catLabel = pathOr('', ['category', 'description'], cur);

                    if (!acc[catName]) {
                        acc[catName] = {
                            code: catName,
                            label: catLabel,
                            items: []
                        };
                    }
                    acc[catName].items.push(cur)
                    return acc;
                }, {});

            setOptionsTransformed(Object.values(optionsDefault));
        }
    }, [options]);

    useEffect(() => {
        stateFieldData.current = defaultValue;
    }, [defaultValue]);
    console.log(stateFieldData, defaultValue);

    return (
        <>
            {!isNil(label)
                ? <label htmlFor={fieldName} className={classNames({ 'p-error': errors[fieldName] })}>
                    {label}{config.required || config.isRequired ?
                    <span className="appForm__field--required">*</span> : null}
                </label> : null}
            <div className={classNames("fileselectInner", { "disabled": disabled })}>
                {addNewMode
                    ? <div className="fileselectInner__selectionBox">
                        <ListBox multiple={multiple}
                                 value={multiple ? selectedUnconfirmed : (selectedUnconfirmed.length > 0 ? selectedUnconfirmed[0] : null)}
                                 onChange={(e) => setSelectedUnconfirmed(multiple ? e.value : (e.value ? [e.value] : []))}
                                 options={optionsTransformed}
                                 optionLabel="name"
                                 optionGroupLabel="label"
                                 optionGroupChildren="items"
                                 className="w-full md:w-14rem"
                                 listStyle={{ maxHeight: '130px' }}/>
                        {!isEmpty(selectedUnconfirmed)
                            ? <Button
                                severity="success"
                                disabled={loading || disabled}
                                onClick={!isNil(attachFilesCallback) ? attachSelectedFilesCallback : attachSelectedFiles}
                                label={multiple ? __('Conferma i file scelti', 'htr') : __('Conferma il file scelto', 'htr')}
                                icon="pi pi-arrow-right" size="small" iconPos="right"/>
                            : <Button
                                severity="success"
                                outlined
                                onClick={doGoBackToListOfFiles}
                                label={__('Torna alla lista dei file selezionati', 'htr')}
                                icon="pi pi-arrow-right" size="small" iconPos="right"/>}
                    </div> : null}
                {!isEmpty(optionsTransformed) && !addNewMode
                    ? <div className="fileselectInner__selectedFiles">
                        <p><strong>{multiple ? __('I file selezionati:', 'htr') : __('Il file selezionato:', 'htr')}</strong></p>
                        <ul>
                            {!isEmpty(stateFieldData.current)
                                ? [...stateFieldData.current].map(o => <li key={o.id}>
                                    {o.name}
                                    {isNil(attachFilesCallback)
                                        ? <div className="appPageSection__iconActions">
                                            <Button icon="pi pi-times" rounded
                                                    type="button"
                                                    size="small"
                                                    disabled={disabled}
                                                    onClick={(e) => confirmDelete(e, o.id)}
                                                    outlined severity="danger"
                                                    aria-label={__('Cancella', 'htr')}/>
                                        </div> : null}
                                </li>) : <li>{__('Nessun file selezionato', 'htr')}</li>}
                        </ul>
                        <Button
                            severity="success"
                            disabled={loading || disabled || (!multiple && !isEmpty(stateFieldData.current))}
                            onClick={() => setAddNewMode(true)}
                            label={multiple ? __('Aggiungi i file', 'htr') : __('Aggiungi il file', 'htr')}
                            icon="pi pi-plus" size="small" iconPos="right"/>
                    </div> : null}
            </div>
            {isEmpty(optionsTransformed)
                ? <div className="appPageSection__message warning">
                    <span>
                        {__('I file caricati sulla pagina Documenti saranno disponibili qui. ', 'htr')}
                        <Link to={`/documenti`}>
                            {__('Vai alla pagina Documenti', 'htr')}
                        </Link>
                    </span>
                </div>
                : null}
            {infoText ? <small>{infoText}</small> : null}
            <ConfirmPopup/>
        </>)
}

export default FileSelect;